{
  "id": "portos",
  "nome": "ANTAQ port installations",
  "fonte": "ANTAQ — Instalações Portuárias Outorgadas (Portos.xlsx)",
  "endpoints": [
    "https://www.gov.br/antaq/pt-br/central-de-conteudos/Instalaesporturias06052025.zip"
  ],
  "capturadoEm": "2026-08-05",
  "atualizadoEm": "2026-08-05T06:10:46.527Z",
  "contagens": {
    "portos": 1094
  },
  "alteracoes": {
    "adicionados": 0,
    "removidos": 0,
    "alterados": 0,
    "comparadoCom": "2026-08-04"
  },
  "verificacao": {
    "agendamento": "diario",
    "workflow": "data-refresh-bot.yml",
    "ultimaExecucao": "2026-08-05T06:10:46.527Z"
  },
  "documentacao": "docs/OFFICIAL-SOURCES.md#portos"
}
